import {useDispatch, useSelector} from "react-redux";
import {
    assetsDialogsSelector,
    cleanCertificates,
    replaceMinMaxLoadedPage,
    setImportCsvDialogAction
} from "../../../store/store";
import {
    getCertificateAssetsAction,
    getCsvFieldsCertificateAction,
    importCsvTemplateCertificateAssetsAction,
    performCsvCertificateAction
} from "../../../store/actions";
import {TImportCsvDialogProps} from "../../../../../../newShared/components/csvImportDialog";
import {resetImportCsvDialog} from "../../../../../../newShared/components/csvImportDialog/constants";
import {
    useGenericFiltersStorage
} from "../../../../../../newShared/components/genericFilter/hooks/useGenericFiltersStorage";
import {DEFAULT_PAGING} from "../../../../../../newShared/components/genericTable/constants";

export const useImportCsvCertificate = (): TImportCsvDialogProps => {
    const dispatch = useDispatch();
    const {importCsvDialog: {
        isOpen,
        isLoading: {
            isGettingFields,
            isPerformingCsv,
            isLoadingTemplate,
        },
        fields,
        fileId,
        response,
    }} = useSelector(assetsDialogsSelector);

    const setImportDialog: TImportCsvDialogProps["setImportDialog"] = (data) => dispatch(setImportCsvDialogAction(data));
    const downloadTemplate = () => {dispatch(importCsvTemplateCertificateAssetsAction())};

    const getFields: TImportCsvDialogProps["getFields"] = (file) => {dispatch(getCsvFieldsCertificateAction({
        data: {...file},
        onError: resetImportCsvDialog,
    }))};

    const {clearFilters} = useGenericFiltersStorage();

    const performCsv: TImportCsvDialogProps["performCsv"] = (fields) => {fileId && dispatch(performCsvCertificateAction({
        data: {fields, fileId},
        // snack: "success",
        // onError: (request, error, addictiveData) => {dispatch(setImportCsvDialogAction({error: error[0]?.message || 'Unknown error'}))},
        onSuccess: (_, response) => {
            clearFilters();
            dispatch(cleanCertificates())
            dispatch(replaceMinMaxLoadedPage({minLoadedPage: -1, maxLoadedPage: -1}));
            dispatch(getCertificateAssetsAction({data: {page: 0, count: DEFAULT_PAGING, filters: {}}}));
        },
    }))};

    return {
        isOpen,
        isLoadingTemplate, isPerformingCsv, isGettingFields,
        fields,
        setImportDialog,
        downloadTemplate,
        getFields,
        performCsv,
        response,
        fieldsMapperKey: "assets",
    }
}
